import React from 'react';

import { theme } from '../GlobalStyles';

import ArrowSvg from './ArrowSvg';

const activeColor = (i, active) => {
  return active === i ? theme.colors.white : theme.colors.purple;
};

const BtnSlider = ({ direction, moveSlide, active, testid, disabled }) => {
  return (
    <button
      onClick={moveSlide}
      className={direction === 'next' ? 'btn-slide next' : 'btn-slide prev'}
      data-testid={testid}
      disabled={disabled}
    >
      <ArrowSvg color={activeColor(direction === 'next' ? 4 : 0, active)} />
    </button>
  );
};

export default BtnSlider;
